<template>
  <div
    v-if="localValue.type === 'checkbox'"
    :id="'localValue' + index"
    :style="
      'margin: ' + styles.margin.join('px ') + 'px;' +
      'text-align: ' + styles.text.textAlign + ';' +
      'color:' + styles.text.color + ';' +
      styles.customStyles ?? ''
    "
  >
    <p
      class="text-sm font-semibold"
      :style="'color: ' + styles.labelColor + ';'"
    >
      {{ localValue.label }}
      <span
        v-if="
          localValue.mandatory === true ||
          localValue.mandatory === 1 ||
          localValue.mandatory === 'true'
        "
        style="color: red; font-weight: bold"
        >*</span
      >
    </p>
    <div
      :style="
        'padding: ' + styles.padding.join('px ') + 'px;' +
        'color:' + styles.color + ';'
      "
    >
      <div
        v-for="(value, index) in localValue.options"
        :key="index"
        class="mt-2 flex"
        :style="
          'justify-content: ' + styles.text.textAlign + ';' +

          'font-family:' + (styles.text.fontFamily || '') + ';' +
          'text-shadow:' + (styles.text.textShadow || '') + ';' +
          'font-size:' + styles.text.fontSize + 'px;' +
          'text-align:' + styles.text.textAlign + ';' +
          'font-style:' + (styles.text.fontStyle || '') + ';' +
          'font-weight:' + (styles.text.fontWeight || '') + ';' +
          'letter-spacing:' + (styles.text.letterSpacing || '') + ';' +
          'line-height:' + (styles.text.lineHeight || '') + ';' +
          '-webkit-text-stroke-width:' + (styles.text.textStrokeWidth || '') + ';' +
          '-webkit-text-stroke-color:' + (styles.text.textStrokeColor || '') + ';' +
          'text-decoration-line:' + (styles.text.textDecorationLine || '') + ';' +
          'color:' + styles.text.color + ';' +
          styles.customStyles ?? ''
        "
      >
        <label class="container text-sm" style="display: inline-block; width: auto;">
          <div v-if="typeof value == 'string'">
            {{ value}}
          </div>
          <div v-else>
            <a
              style="text-decoration: underline"
              target="_blank"
              :href="value.link"
            >{{ value.text }}</a>
          </div>
          <input type="checkbox"/>
          <span
            class="checkmark"
            :style="
            '--form-style-color:' + styles.iconColor + ';' +
            '--form-style-background:' + styles.backgroundColor"
          ></span>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'FormCheckbox',
  props: {
    value: {
      required: true,
    },
    index: {
      required: true,
    },
    styles: {
      required: true,
    },
  },
  computed: {
    localValue: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    hide() {
      this.localValue = '';
      this.localShown = false;
    },
    onTextChange(e) {
      console.log(e.target.innerText);
      this.localValue = e.target.innerText;
    },
  }
}
</script>
